import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProductClass } from '../models/product-class.model';

@Injectable({
  providedIn: 'root'
})
export class ProductClassService {

  /**
  * Endpoint for http calls
  */
  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  /**
   * Get a product class from the backend by id
   *
   * @param id number id of product class to get
   *
   * @returns Observable<ProductClass>
   */
  getProductClassById(id: number): Observable<ProductClass> {

    if (id <= 0 || id === null || id === undefined) {
      throw new Error('ProductClassService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'product-class/' + id).pipe(map((value: any) => {
      return <ProductClass>value;
    }));
  }

  getAllProductClasses(): Observable<ProductClass[]> {
    return this.httpClient.get(this._endpoint + 'product-class?sort=name,ASC').pipe(map((data) => {
      return <ProductClass[]>data;
    }));
  }

  /**
   * creates a product class in the backend based on product class object.
   *
   * @param productClass product class object.
   *
   * @returns Observable<ProductClass>
   */
  createProductClass(productClass: ProductClass): Observable<ProductClass> {

    if (!productClass) {
      throw new Error('product class service: you must supply a product class object for saving');
    }

    delete productClass.createdAt;
    delete productClass.updatedAt;

    if (productClass.id > 0) {
      throw new Error('product class service: Cannot create a existing object');
    }

    delete productClass.id;

    return this.httpClient.post(this._endpoint + 'product-class',
      JSON.stringify(productClass),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <ProductClass>data;
      }));
  }

  /**
   * updates a product class in the backend based on product class object.
   *
   * @param productClass product class object.
   *
   * @returns Observable<ProductClass>
   */
  updateProductClass(productClass: ProductClass): Observable<ProductClass> {

    if (!productClass) {
      throw new Error('product class service: you must supply a product class object for saving');
    }

    delete productClass.createdAt;
    delete productClass.updatedAt;

    if (!productClass.id || productClass.id === -1) {
      throw new Error('product class service: Cannot update an record without id');
    }

    return this.httpClient.put(this._endpoint + 'product-class/' + productClass.id,
      JSON.stringify(productClass),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <ProductClass>data;
      }));
  }
}
